// eslint-disable-next-line no-restricted-imports
import styled from 'styled-components';
import { devices } from 'utils/styledHelpers';

export const ResourcesSection = styled.section`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 80px 0 80px 0;
  width: 100%;

  ${devices.medium} {
    padding: 80px 0 80px 0;
  }

  ${devices.small} {
    padding: 80px 0 80px 0;
  }

  ${devices.xsmall} {
    padding: 80px 0 80px 0;
  }

  .content {
    align-items: center;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    width: 100%;

    ${devices.medium} {
      gap: 24px;
    }

    ${devices.small} {
      gap: 24px;
    }

    ${devices.xsmall} {
      gap: 48px;
    }

    .content-info {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .description {
        color: #312f4f;
        font-size: 18px;
        font-weight: 400;
        line-height: 150%;
        margin-bottom: 64px;
        margin-top: 8px;
        text-align: center;
      }

      h2 {
        color: #312f4f;
        font-size: 40px;
        font-weight: 700;
        line-height: 120%;
      }

      ${devices.large} {
        h2 {
          font-size: 40px;
          font-weight: 700;
          line-height: 48px;
          text-align: center;
        }
      }

      ${devices.medium} {
        h2 {
          font-size: 32px;
          font-weight: 700;
          line-height: 120%;

          text-align: center;
        }
      }

      ${devices.small} {
        h2 {
          font-size: 32px;
          font-weight: 700;
          line-height: 120%;
          text-align: center;
        }
      }

      ${devices.xsmall} {
        h2 {
          font-size: 32px;
          font-weight: 700;
          line-height: 120%;
          text-align: center;
        }
      }
    }

    .resources-container {
      display: flex;
      flex-direction: column;
      gap: 56px;

      .resources {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .resource-title {
          border-bottom: 1px solid #abc6ff;
          color: #0c29d0;
          font-size: 22px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          padding-bottom: 10px;
        }

        .resources-content {
          display: grid;
          gap: 40px;
          grid-template-columns: 1fr 1fr 1fr;

          ${devices.medium} {
            grid-template-columns: 1fr;
          }
          ${devices.mobile} {
            grid-template-columns: 1fr;
          }

          .resource-item {
            align-items: center;
            display: flex;
            gap: 16px;
            height: 100%;

            .resource-item-title-container {
              display: flex;
              align-items: center;

              .featured-badge {
                background: #9905e8;
                border-radius: 10px 0px 10px 0px;
                color: #fff;
                font-size: 13px;
                font-weight: 600;
                padding: 3px 6px 3px 6px;
                width: fit-content;
                display: flex;
                align-items: center;
                justify-content: center;
                height: fit-content;
                line-height: 100%;
                gap: 4px;
              }

              .resource-item-title {
                color: #312f4f;
                font-size: 18px;
                font-weight: 700;
                line-height: 150%;
                display: flex;
                gap: 10px;
                flex-wrap: wrap;
                margin-right: 10px;
              }
            }

            .resource-item-description {
              color: #312f4f;
              font-size: 16px;
              font-weight: 400;
              line-height: 150%;
            }
          }
        }
      }
    }
  }
`;
